export default __webpack_public_path__ + "static/media/leftarrow.e0a589f8.webp";